module.exports = __webpack_public_path__ + "static/media/devin_guillory.32066185.jpg";